import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./PopupModal.css";

export default function PopupModal({ show, onClose, popup }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const gid = popup?.guide?._id || "";

  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [show]);

  if (!show || !popup) return null;

  const title = popup.guide?.title || popup.title;
  const desc = popup.guide?.desc || popup.desc;
  const image = popup.guide?.image?.url || popup.image;

  const isValidEmail = (email) => {
    const emailRegex =
      /^(?!.*\.\.)[a-zA-Z0-9][a-zA-Z0-9._%+-]{0,63}@[a-zA-Z0-9][a-zA-Z0-9-]{0,253}\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const cleanEmail = email.trim();

    // 🔹 Custom validation
    if (!cleanEmail) {
      setError(true);
      setMessage("Please enter an Email ID.");
      return;
    }

    if (!isValidEmail(cleanEmail)) {
      setError(true);
      setMessage("Please enter a valid Email ID.");
      return;
    }

    const data = {
      email: cleanEmail,
      siteId: process.env.SITE_KEY,
      gid,
      site: process.env.SITE_KEY,
    };

    try {
      setLoading(true);
      const res = await fetch(
        `${process.env.REACT_APP_PUBLIC_API_URL}/getguides`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        }
      );

      const result = await res.json();
      setMessage(result.message || "Guide sent to your email successfully.");

      setEmail("");
      setTimeout(() => {
        onClose();
        setMessage("");
      }, 20000);
    } catch (err) {
      console.error("Failed to submit the form:", err);
      setMessage("❌ Failed to submit the form. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return createPortal(
    <div className="popup-overlay">
      <div className="popup-wrapper">
        <div className="popup-left">
          {image && <img src={image} alt={title} className="popup-image" />}
        </div>

        <div className="popup-right">
          <button className="popup-close" onClick={onClose}>
            ✕
          </button>

          <p className="popup-desc">{desc}</p>
          <h2 className="popup-title">{title}</h2>
          <form className="popup-form" onSubmit={handleSubmit} noValidate>
            <input
              type="email"
              placeholder="Email ID"
              className="popup-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="popup-btn" disabled={loading}>
              {loading ? "Sending..." : "Start Now!"}
            </button>

            {message && (
              <p
                style={{
                  marginTop: "10px",
                  color: error ? "red" : "green",
                }}
              >
                {message}
              </p>
            )}
          </form>
        </div>
      </div>
    </div>,
    document.body
  );
}
